import {
  AccountCircleRounded,
  AltRouteRounded,
  AssignmentRounded,
  BadgeRounded,
  CalendarMonthRounded,
  CampaignRounded,
  CategoryRounded,
  CurrencyRupeeRounded,
  DescriptionRounded,
  DirectionsBusRounded,
  EventBusyRounded,
  EventAvailableRounded,
  FamilyRestroomRounded,
  FormatListBulletedRounded,
  GroupsRounded,
  HistoryEduRounded,
  LibraryBooksRounded,
  LocalLibraryRounded,
  ManageAccountsRounded,
  PersonAddAlt1Rounded,
  QuestionAnswerRounded,
  ReceiptLongRounded,
  RequestQuoteRounded,
  ScheduleRounded,
  SendRounded,
  SettingsRounded,
  SpaceDashboardRounded,
  SvgIconComponent,
  SwapHorizRounded,
  TuneRounded,
  UploadFileRounded,
  WalletRounded,
} from "@mui/icons-material";
import { AcademicSettingsIcon } from "./AcademicSettingsIcon";

/** Dashboard / Home (sidebar, rail and phone bottom bar). */
export const DashboardIcon = SpaceDashboardRounded;

// One consistent set: MUI "Rounded" icons only. Keys must match the `icon` strings in menuConfig.ts.
export const menuIconMap: Record<string, SvgIconComponent> = {
  // groups
  attendance: EventAvailableRounded,
  students: GroupsRounded,
  finance: CurrencyRupeeRounded,
  enquiries: QuestionAnswerRounded,
  notifications: CampaignRounded,
  staff: BadgeRounded,
  academics: AcademicSettingsIcon,
  users: ManageAccountsRounded,
  settings: SettingsRounded,
  transport: DirectionsBusRounded,
  library: LocalLibraryRounded,
  my_space: AccountCircleRounded,

  // items
  add: PersonAddAlt1Rounded,
  list: FormatListBulletedRounded,
  import: UploadFileRounded,
  guardians: FamilyRestroomRounded,
  transfer_certificate: DescriptionRounded,
  attendance_students: GroupsRounded,
  attendance_staff: BadgeRounded,
  outstanding: RequestQuoteRounded,
  receipts: ReceiptLongRounded,
  payments: WalletRounded,
  fee_structure: CategoryRounded,
  setup: TuneRounded,
  timetable: ScheduleRounded,
  year_transition: SwapHorizRounded,
  academic_years: CalendarMonthRounded,
  send: SendRounded,
  system: TuneRounded,
  routes_schedule: AltRouteRounded,
  assignment: AssignmentRounded,
  catalog: LibraryBooksRounded,
  history: HistoryEduRounded,
  leave: EventBusyRounded,
  substitutions: SwapHorizRounded,
};
